import { brandTokens } from '../theme';

export const pageTitleSx = {
  color: 'primary.main',
  fontWeight: 800
};

export const actionButtonSx = {
  bgcolor: 'primary.main',
  '&:hover': {
    bgcolor: 'primary.dark'
  }
};

export const filterCardSx = {
  p: 2,
  mb: 2,
  bgcolor: 'background.paper',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  boxShadow: `0 10px 28px ${brandTokens.shadow}`
};

export const formCardShadow = `0 12px 34px ${brandTokens.shadow}`;

export const modalSurfaceSx = {
  bgcolor: 'background.paper',
  border: `2px solid ${brandTokens.border}`,
  borderRadius: 1,
  boxShadow: 24
};

export const overlaySx = {
  bgcolor: 'var(--color-overlay)',
  color: 'common.white'
};
